import PageHeader from 'components/PageHeader';
import Footer from 'components/PageFooter';

const LegalNotice: React.FC = () => {
  return (
    <div className="flex flex-col min-h-screen bg-gray-50 dark:bg-gray-900">
      <PageHeader />
      <div className="max-w-4xl mx-auto py-8 px-4 sm:px-6 lg:px-8 flex-1">
        <h2 className="text-5xl font-bold text-gray-900 dark:text-white mb-2 text-center mt-5">
          Legal notice
        </h2>
        <p className="text-gray-600 dark:text-gray-400 mt-4 ml-2 mt-10">
          While we do our best to ensure that all information on this website is correct and up to date, it is impossible to guarantee that this is always the case. We cannot accept responsibility for any information that may be outdated or may contain errors or omissions. The information is subject to change without notice.
        </p>
        <p className="text-gray-600 dark:text-gray-400 mt-4 ml-2">
          Please get in touch with us for the most up-to-date information. We cannot accept any responsibility or liability for the improper operation and the availability of this site or for the reliance by any person on the site content. Should you have any further questions regarding these matters please do not hesitate to contact us.
        </p>

        <h3 className="text-2xl font-bold text-gray-900 dark:text-white mb-2 mt-10">
          Copyright notice
        </h3>
        <p className="text-gray-600 dark:text-gray-400 mt-4 ml-2">
          Unless otherwise specified, all material on this site is copyrighted and may not be used except as laid down in any other proprietary notice provided with the relevant material. The material contained on this site may not be downloaded or copied without written permission from the relevant copyright owner. All brand names and trademarks are owned by their respective owners. Should you have any further questions regarding these matters please do not hesitate to contact us.
        </p>
      </div>
      <Footer />
    </div>
  )
}

export default LegalNotice;